import {ValidationErrors, AbstractControl } from '@angular/forms';

/**
 * Funzione per controllare se il valore passato sia vuoto o null
 * @param value 
 * @returns 
 */
function isEmptyInputValue(value: any): boolean {
    return (value == null || value === '' || value.length === 0);
  }

export class MinNumValidators{

    /**
     * Custom Validator per il controllo sulla quantità di articoli ricevuti
     * se si inserisce un un numero minore di quello passato inizialmente va in errorre
     * @param numRec Il numero della quantità ricevuta
     * @returns ritorna null se il numero è indefinito, null oppure il numero immesso è minore di quello iniziale
     */
    public static numMin(numRec: number): ValidationErrors | null {
        if (numRec === undefined || numRec === null) {
          return null;
        }
    
        return (control: AbstractControl): ValidationErrors | null => {
          if (isEmptyInputValue(control.value)) {
            return null;
          }
          const value = (control.value);
          return value < numRec ? {'NumMin': true } : null;
        };
      }


}





// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-catalog-gift-received-store/loyalty-catalog-gift-received-store-detail/min-num-validators.ts